/**
 * Created by Ding on 05/05/2017.
 */

import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRedirect, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import configure from './store/configureStore';

import Hunter from './pages/hunter/Hunter';
import Login from './pages/hunter/Login';
import ResetPassword from './pages/hunter/ResetPassword';
import Tabs from './pages/hunter/Tabs';
import Positions from './pages/hunter/Positions';
import Position from './pages/hunter/Position';
import RecommendCandidate from './pages/hunter/RecommendCandidate';
import Candidates from './pages/hunter/Candidates';
import Candidate from './pages/hunter/Candidate';
import parseRoute from './utils/routeParser';

import './style/base.less';


// Mirror
window.taotieCommandQueue = window.taotieCommandQueue || [];
if (window.location.host === 'recruit.didichuxing.com') {
    window.taotieCommandQueue.push({
        command: 'setCookieSystemNameForTaotie',
        parameter: 'Recruit',
    });
} else {
    window.taotieCommandQueue.push({
        command: 'setCookieSystemNameForTaotie',
        parameter: 'RecruitTest',
    });
}
window.taotieCommandQueue.push({
    command: 'setCookieUserName',
    parameter: 'cookie_user_en',
});


const store = configure({});
browserHistory.listen((location) => {
    parseRoute(location.pathname);
    return location;
});

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory} onUpdate={() => window.scrollTo(0, 0)}>
            <Route path="/" component={Hunter}>
                <Route path="login" component={Login} />
                <Route path="reset" component={ResetPassword} />
                <Route component={Tabs}>
                    <IndexRedirect to="positions" />
                    <Route path="positions" component={Positions} />
                    <Route path="candidates" component={Candidates} />
                </Route>
                <Route path="position_:positionId">
                    <Route path="detail" component={Position} />
                    <Route path="recommend_candidate" component={RecommendCandidate} />
                </Route>
                <Route path="candidate">
                    <Route path=":candidateId" component={Candidate} />
                </Route>
            </Route>
        </Router>
    </Provider>,
    document.getElementById('root'),
);
